import _ from 'lodash';
import memoizeOne from 'memoize-one';
import { createSelector } from 'reselect';

import { getPagePermissions } from 'utils/permissions';

import { getMasterPermissions } from 'store/auth/selectors';

export const getAvailableTabs = memoizeOne(
  (tabsConfig, isInternalAccess) =>
    createSelector([getMasterPermissions], masterPermissions => {
      return tabsConfig.reduce((acc, tab) => {
        const { pageCode } = tab;
        const newPageCode = isInternalAccess ? pageCode.internal : pageCode.default;

        if (getPagePermissions(newPageCode)(masterPermissions).isViewAllowed) {
          acc.push({ ...tab, pageCode: newPageCode });
        }

        return acc;
      }, []);
    }),
  _.isEqual,
);
